import Repository from './Repository'
const URL_GET_MEDICINE_COLOR = '/medicine-colors'

export default {
  getMedicineColors () {
    return Repository.get(URL_GET_MEDICINE_COLOR)
  }
}
